var React = require('react');

function Dashboard (props) {
    return React.createElement("svg",props,[React.createElement("rect",{"x":"2.5","y":"2.5","width":"6","height":"6","rx":"0.5","stroke":"#3F3F3F","key":0}),React.createElement("rect",{"x":"11.5","y":"2.5","width":"6","height":"6","rx":"0.5","stroke":"#3F3F3F","key":1}),React.createElement("rect",{"x":"2.5","y":"11.5","width":"6","height":"6","rx":"0.5","stroke":"#3F3F3F","key":2}),React.createElement("rect",{"x":"11.5","y":"11.5","width":"6","height":"6","rx":"0.5","stroke":"#3F3F3F","key":3})]);
}

Dashboard.defaultProps = {"width":"20","height":"20","viewBox":"0 0 20 20","fill":"none"};

module.exports = Dashboard;

Dashboard.default = Dashboard;
